try {
    window.$ = window.jQuery = require('jquery');

} catch (e) {}

window.moment = require('moment');


// WEBPACK FOOTER //
// ./src/js/bootstrap.js